import { memo } from "react";
import DialogComponent from "../../../../commons/components/Modal/DialogComponent"


type Props = {
  callDeleteVideo: Function,
  handleClose: Function,
  statusDelete: Boolean,
  className: String
}

const DialogConfirmDelComponent = (({callDeleteVideo, handleClose, statusDelete, className}:Props) => {
  return (
    <DialogComponent 
      id={`js-delete-album`} 
      children={``} 
      show={statusDelete} 
      title={`알림`} 
      closeBtn={`취소`}
      customBtn={`확인`}       
      handleCustom={callDeleteVideo}  
      handleClose={handleClose}
      className={className}
    >
      <div className="content-dialog">
        정말 삭제하시겠습니까? <br />
        삭제 후에는 영상 복구가 불가능합니다
      </div>
    </DialogComponent>
  )
})

export default memo(DialogConfirmDelComponent);
